<template>
    <div class="flex flex_column">
        <div v-for="account in accounts" :key="account.id" class="flex">
            <md-field displayOnly class="margin_horizontal" style="width: 100px">
                <label>{{ $t("common.currency") }}</label>
                <md-input :value="account.tbCurrType" disabled></md-input>
            </md-field>
            <md-checkbox v-model="accountLimitMapping[account.id].withoutLimit"
                         :disabled="!canEditLimits"
                         class="margin_r" style="width: 120px">
                <span>{{ $t("manageUser.limits.without") }}</span>
            </md-checkbox>
            <md-field v-show="!accountLimitMapping[account.id].withoutLimit" class="margin_r flex_1">
                <label>{{ $t("manageUser.limits.sell") }}</label>
                <MoneyAmountInput v-model="accountLimitMapping[account.id].maxSellAmount"
                                  :disabled="!canEditLimits"
                ></MoneyAmountInput>
            </md-field>
        </div>
        <div class="text_left light_bg_color margin_horizontal">
            <span class="font_bold">{{$t("common.hint")}}:</span>
            <br/>
            <span>{{$t("manageUser.limits.sell.hint")}}</span>
        </div>
    </div>
</template>

<script>
import MoneyAmountInput from "@/components/templates/common/MoneyAmountInput";

export default {
    props: {
        accounts: { type: Array, default: null },
        limits: { type: Array, default: null },
        canEditLimits: { type: Boolean, default: false },
    },
    components: {
        MoneyAmountInput
    },
    data() {
        return {
            accountLimitMapping: this.buildAccountLimitMapping()
        };
    },
    methods: {
        buildAccountLimitMapping() {
            let mapping = {};

            this.accounts.forEach(account => {
                let limit = this.limits ? this.limits.find(limit => limit.accountId === account.id) : null;

                // defaults if no limit exists
                if (!limit) {
                    limit = { hasSellLimit: false, maxSellAmount: 0 }
                }

                mapping[account.id] = {
                    withoutLimit: !limit.hasSellLimit,
                    maxSellAmount: limit.maxSellAmount,
                };
            });

            return mapping;
        },
        getLimits() {
            let limits = [];

            for (let accountId in this.accountLimitMapping) {
                let accountLimit = this.accountLimitMapping[accountId];

                limits.push({
                    accountId: accountId,
                    hasSellLimit: !accountLimit.withoutLimit,
                    maxSellAmount: !accountLimit.withoutLimit ? accountLimit.maxSellAmount : null
                });
            }

            return limits;
        }
    },
};
</script>